import routes from '@configs/api'
import { User } from '@type/user'
import AxiosClient from '@services/api/base'
import normalizeUser from '@utils/normalizeUser'
import { AUTH_TOKEN_KEY } from '@constants/localstorageKeys'
import Cookies from 'js-cookie'

const updateAvatar = (avatarFile: File) => {
  return new Promise<User>(async (resolve, reject) => {
    const tokenId = Cookies.get(AUTH_TOKEN_KEY)
    const url = `${routes.USER}/avatar`

    const formData = new FormData()
    formData.append('avatar', avatarFile)

    const config = {
      headers: {
        Authorization: `Bearer ${tokenId}`,
        'Content-Type': 'multipart/form-data',
      },
    }

    AxiosClient.put(url, formData, config)
      .then((res) => {
        const user: User = normalizeUser(res.data)
        resolve(user)
      })
      .catch((err) => {
        reject('Error updating avatar: ' + err)
      })
  })
}

export default updateAvatar
